import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {SheetsLoader} from '../helpers/core/sheets-loader';

@Injectable()
export class RouteGuard implements CanActivate {
    constructor(private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        try {
            const parent_route = route.routeConfig.path;
            if (parent_route === 'tracker') {
                SheetsLoader.loadSheet('tracker');
            } else {
                SheetsLoader.loadSheet('style');
            }
            return true;
        } catch (e) {
            this.router.navigate(['login'], {queryParams: {returnUrl: state.url}});
            return false;
        }
    }
}
